// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ErrorAlert: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M9 18c4.972 0 9-4.028 9-9s-4.028-9-9-9-9 4.028-9 9 4.028 9 9 9Zm2.359-4.587L9 11.033l-2.362 2.38a.436.436 0 0 1-.617 0l-1.434-1.437a.436.436 0 0 1 0-.617L6.967 9l-2.38-2.362a.436.436 0 0 1 0-.617l1.437-1.438c.17-.17.447-.17.617 0L9 6.968l2.362-2.38c.171-.171.447-.171.617 0l1.438 1.436c.17.17.17.447 0 .617L11.032 9l2.38 2.362c.171.171.171.447 0 .617l-1.436 1.434a.436.436 0 0 1-.617 0Z"
            />
        </svg>
    );
};

export default React.memo(ErrorAlert);
